import { Container } from '@utils-global';
import * as Sentry from '@sentry/react';
import { routes } from '../constants';
import { getGraphErrorContext } from './helpers';

export const getMailParentFolderId = async (
  mailId: string,
  userEmail: string,
): Promise<string | null> => {
  try {
    const response = await Container.graphClient.get(
      routes.office.getMailParentFolder(mailId, userEmail),
    );

    return response?.data?.parentFolderId ?? null;
  } catch (error) {
    Sentry.logger.warn('Mail parent folder could not be read', {
      mailId,
      ...getGraphErrorContext(error),
    });

    return null;
  }
};
